module.exports = {
    group: 'form-group field-name ',
    label: "col-sm-2 control-label",
    error: 'error-block help-block',
    help: 'help-block',
    hasTitle: "col-sm-10",
    noTitle: "col-sm-12"
}


/** WEBPACK FOOTER **
 ** ./src/styles/EditorTemplate-style.js
 **/